export const ADD_PRODUCT_TEXT = 'Add Product'
export const ADD_MS_ONLY_TEXT = 'Add MasterSpec options only'
export const ADD_MS_AND_MFR_TEXT = 'Add MasterSpec and Manufacturer options'
export const SELECT_TEXT = 'Select'
export const CANCEL_TEXT = 'Cancel'
export const CONTINUE_TEXT = 'Continue'
export const CAUTION_TEXT = 'Caution'

export const MSONLY_INSTRUCTION_TEXT =
    'Select this option to add available MasterSpec property options to your project.'
export const MS_MFR_INSTRUCTION_TEXT =
    'Select this option to add both available MasterSpec options and additional Manufacturer options to your project.'
export const MS_MFR_INSTRUCTION_SUB_TEXT =
    "Adding Manufacturer options may introduce proprietary aspects to the product you are adding. Additional research may be required for bidding purposes.To learn more about the product, reach out to the contact located on the cards' resources tab"

export const WARNING_TEXT = 'Warning'

export const ADD_PROJECT_MANUFACTURER_WARNING_TEXT = `You have selected a Manufacturer Product Type to add to your project.\n
This product type was added by one or more manufacturers and not the MasterSpec
content team. Adding a Manufacturer Product Type will make available products with
Manufacturer Options.\n
These options may introduce proprietary aspects to your project. Additional research 
may be required for bidding purposes.`

export const REMOVE_MO_TEXT = `The product you have selected to add to the project does not
have Manufacturer Options on its properties. Other products
that have been added from this Product Type have
Manufacturer Options. \n \n If you add this product, all products with Manufacturer
Options will be removed from the project. Do you want to
continue?`

export const REMOVE_MS_TEXT = `The product you have selected to add to the project has
Manufacturer Options on its properties. None of the other
products that have been added from this Product Type have
Manufacturer Options. \n\n If you add this product, all products without Manufacturer
Options will be removed from the project. Do you want to
continue?`

export const versionControlBarMarginOM = 145
export const smmWorkspaceElementsPanelMargin = 65
export const aeWorkspaceElementsPanelMargin = 110
